module.exports = __webpack_public_path__ + "img/dieselengineexhaust_icon.99c4ebdb.svg";